const MENU_DATA_VER = '2023-03-06T05:15:08.504Z';

const MENU_DATA = [
  {
    "GNB": false,
    "LNB": "",
    "예상소요": 6,
    "실제소요": "6 + 1",
    "뎁스1": "메인",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "PageMain",
    "진행 단계": "완료",
    "이슈": "https://gitlab.commerceon.co.kr/commerceon/homepage/-/issues/3",
    "기획": "https://dmsw19.axshare.com/#id=081b5e&p=%EB%A9%94%EC%9D%B8&g=1&sc=3",
    "디자인": "https://www.figma.com/file/8Tczs8cVyZwnDRYWIv7rpa/2022-Commerceon-Renewal?node-id=775%3A2270&t=LHvk4Zgumc4erznC-1",
    "HREF": "",
    "child": [],
    "path": "메인"
  },
  {
    "GNB": true,
    "LNB": "",
    "예상소요": 3,
    "실제소요": 3,
    "뎁스1": "이커머스 솔루션 소개",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "PageIntroduction",
    "진행 단계": "완료",
    "이슈": "https://gitlab.commerceon.co.kr/commerceon/homepage/-/issues/4",
    "기획": "https://dmsw19.axshare.com/#id=hvjgcx&p=%EC%86%94%EB%A3%A8%EC%85%98%EC%86%8C%EA%B0%9C&g=1&sc=3",
    "디자인": "https://www.figma.com/file/8Tczs8cVyZwnDRYWIv7rpa/2022-Commerceon-Renewal?node-id=775%3A2270&t=LHvk4Zgumc4erznC-1",
    "HREF": "",
    "child": [],
    "path": "이커머스 솔루션 소개"
  },
  {
    "GNB": true,
    "LNB": "",
    "예상소요": 3,
    "실제소요": "2 - 1",
    "뎁스1": "디자인",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "PageDesign",
    "진행 단계": "완료",
    "이슈": "https://gitlab.commerceon.co.kr/commerceon/homepage/-/issues/5",
    "기획": "https://dmsw19.axshare.com/#id=cl4gi6&p=%EB%94%94%EC%9E%90%EC%9D%B8&g=1&sc=3",
    "디자인": "https://www.figma.com/file/8Tczs8cVyZwnDRYWIv7rpa/2022-Commerceon-Renewal?node-id=775%3A2270&t=LHvk4Zgumc4erznC-1",
    "HREF": "",
    "child": [],
    "path": "디자인"
  },
  {
    "GNB": true,
    "LNB": "",
    "예상소요": 3,
    "실제소요": "2 - 1",
    "뎁스1": "통합물류 솔루션",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "PageLogistics",
    "진행 단계": "완료",
    "이슈": "https://gitlab.commerceon.co.kr/commerceon/homepage/-/issues/5",
    "기획": "https://dmsw19.axshare.com/#id=cl4gi6&p=%EB%94%94%EC%9E%90%EC%9D%B8&g=1&sc=3",
    "디자인": "https://www.figma.com/file/8Tczs8cVyZwnDRYWIv7rpa/2022-Commerceon-Renewal?node-id=775%3A2270&t=LHvk4Zgumc4erznC-1",
    "HREF": "",
    "child": [],
    "path": "물류센터 솔루션"
  },
  {
    "GNB": true,
    "LNB": "",
    "예상소요": 1,
    "실제소요": 1,
    "뎁스1": "고객센터",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "PageCustomerService",
    "진행 단계": "완료",
    "이슈": "https://gitlab.commerceon.co.kr/commerceon/homepage/-/issues/6",
    "기획": "https://dmsw19.axshare.com/#id=t2bxz3&p=%EA%B3%A0%EA%B0%9D%EC%84%BC%ED%84%B0&g=1&sc=3",
    "디자인": "https://www.figma.com/file/8Tczs8cVyZwnDRYWIv7rpa/2022-Commerceon-Renewal?node-id=775%3A2270&t=LHvk4Zgumc4erznC-1",
    "HREF": "",
    "child": [],
    "path": "고객센터"
  },
  {
    "GNB": true,
    "LNB": "",
    "예상소요": 7,
    "실제소요": 3,
    "뎁스1": "컨설팅",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "PageConsulting",
    "진행 단계": "완료",
    "이슈": "https://gitlab.commerceon.co.kr/commerceon/homepage/-/issues/7",
    "기획": "https://dmsw19.axshare.com/#id=bp06gj&p=%EC%BB%A8%EC%84%A4%ED%8C%85&g=1&sc=3",
    "디자인": "https://www.figma.com/file/8Tczs8cVyZwnDRYWIv7rpa/2022-Commerceon-Renewal?node-id=775%3A2270&t=LHvk4Zgumc4erznC-1",
    "HREF": "",
    "child": [],
    "path": "컨설팅"
  },
  {
    "GNB": "",
    "LNB": "",
    "예상소요": 0,
    "실제소요": "0 + 0.5",
    "뎁스1": "개인정보처리방침",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "PagePersonalDataPolicy",
    "진행 단계": "완료",
    "이슈": "https://gitlab.commerceon.co.kr/commerceon/homepage/-/issues/10",
    "기획": "https://dmsw19.axshare.com/#id=lb8cdh&p=%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4%EC%B2%98%EB%A6%AC%EB%B0%A9%EC%B9%A8&g=1&sc=3",
    "디자인": "https://www.figma.com/file/8Tczs8cVyZwnDRYWIv7rpa/2022-Commerceon-Renewal?node-id=775%3A2270&t=LHvk4Zgumc4erznC-1",
    "HREF": "",
    "child": [],
    "path": "개인정보처리방침"
  },
  {
    "GNB": "",
    "LNB": "",
    "예상소요": "",
    "실제소요": "",
    "뎁스1": "Markup reference",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "",
    "진행 단계": "완료",
    "이슈": "",
    "기획": "",
    "디자인": "",
    "HREF": "",
    "child": [
      {
        "GNB": "",
        "LNB": "",
        "예상소요": "",
        "실제소요": "",
        "뎁스1": "",
        "뎁스2": "사이트맵",
        "뎁스3": "",
        "PAGE": "PageSitemap",
        "진행 단계": "완료",
        "이슈": "",
        "기획": "",
        "디자인": "",
        "HREF": "",
        "child": [],
        "path": "Markupreference/사이트맵"
      },
      {
        "GNB": "",
        "LNB": "",
        "예상소요": "",
        "실제소요": "",
        "뎁스1": "",
        "뎁스2": "템플릿",
        "뎁스3": "",
        "PAGE": "PageTemplate",
        "진행 단계": "",
        "이슈": "",
        "기획": "",
        "디자인": "",
        "HREF": "",
        "child": [],
        "path": "Markupreference/템플릿"
      },
      {
        "GNB": "",
        "LNB": "",
        "예상소요": 0,
        "실제소요": "0 + 1",
        "뎁스1": "",
        "뎁스2": "레이어팝업 모음",
        "뎁스3": "",
        "PAGE": "PageLayerPopSample",
        "진행 단계": "",
        "이슈": "",
        "기획": "",
        "디자인": "",
        "HREF": "",
        "child": [],
        "path": "Markupreference/레이어팝업모음"
      }
    ],
    "path": "Markupreference"
  },
  {
    "GNB": "",
    "LNB": "",
    "예상소요": "",
    "실제소요": "",
    "뎁스1": "라이브러리",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "",
    "진행 단계": "완료",
    "이슈": "",
    "기획": "",
    "디자인": "",
    "HREF": "",
    "child": [
      {
        "GNB": "",
        "LNB": "",
        "예상소요": "",
        "실제소요": "",
        "뎁스1": "",
        "뎁스2": "swiperjs 샘플",
        "뎁스3": "",
        "PAGE": "PageSwiperjs",
        "진행 단계": "",
        "이슈": "",
        "기획": "",
        "디자인": "",
        "HREF": "",
        "child": [],
        "path": "라이브러리/swiperjs샘플"
      }
    ],
    "path": "라이브러리"
  },
  {
    "GNB": "",
    "LNB": "",
    "예상소요": "",
    "실제소요": "",
    "뎁스1": "Tailwind",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "https://tailwindcss.com/",
    "진행 단계": "완료",
    "이슈": "",
    "기획": "",
    "디자인": "",
    "HREF": "",
    "child": [],
    "path": "Tailwind"
  },
  {
    "GNB": "",
    "LNB": "",
    "예상소요": "",
    "실제소요": "",
    "뎁스1": "Sweetalert",
    "뎁스2": "",
    "뎁스3": "",
    "PAGE": "https://sweetalert.js.org/",
    "진행 단계": "완료",
    "이슈": "",
    "기획": "",
    "디자인": "",
    "HREF": "https://tailwindcss.com/",
    "child": [],
    "path": "Sweetalert"
  }
];

export { MENU_DATA, MENU_DATA_VER };
